export default "__VITE_ASSET__Bhvv_qvP__"